import appApi from "@/api/appApi";

export default {
  async getRecentPhotos() {
    const { data } = await appApi.get("/vk/foto-last");
    if (data.success) {
      data.data = data.data.albums.items
        .map(item => {
          const preview = item.sizes.find(photo => photo.type === "q");
          const photo = item.sizes.find(photo => photo.type === "z");
          return {
            preview,
            photo,
            text: item.text
          };
        })
        .filter(photo => !!photo);
    }
    return data;
  },

  async getAlbums() {
    const { data } = await appApi.get("/vk/albums");
    if (data.success) {
      data.data = data.data.albums.items
        .map(item => {
          const img = item.sizes.find(photo => photo.type === "q");
          return {
            img,
            id: item.id,
            title: item.title
          };
        })
        .filter(item => !!item.img);
    }
    return data;
  },

  async getAlbumPhotos(slug, offset) {
    const { data } = await appApi.get(
      `/vk/album-foto?album_id=${slug}&offset=${offset}`
    );
    if (data.success) {
      data.data.photos = data.data.albums.items
        .map(item => {
          const preview = item.sizes.find(photo => photo.type === "q");
          const photo = item.sizes.find(photo => photo.type === "z");
          return {
            preview,
            photo,
            text: item.text
          };
        })
        .filter(photo => !!photo);
      delete data.data.albums;
    }
    return data;
  }
};
